// The pure parts of the domain list reads: how a response body becomes a page, and which sort the
// table's columns ask the backend for. No HTTP, no React: tests/raven runs them on recorded bodies.
import type { CDNDomain, PaginatedDomainList } from './domains';

/**
 * A list body as a page. vEdge answers `pagination` with a `total`, but a body without one must not
 * read as "no domains": the total then falls back to what is on hand (rows up to this page), never 0
 * over existing rows.
 */
export function shapeDomainPage(
  body: { data?: unknown; pagination?: { page?: number; per_page?: number; total?: number } } | null | undefined,
  q: { page: number; perPage: number },
): PaginatedDomainList {
  const data = Array.isArray(body?.data) ? (body.data as CDNDomain[]) : [];
  const p = body?.pagination;
  return {
    data,
    pagination:
      p && typeof p.total === 'number'
        ? { page: p.page ?? q.page, per_page: p.per_page ?? q.perPage, total: p.total }
        : { page: q.page, per_page: q.perPage, total: data.length ? (q.page - 1) * q.perPage + data.length : 0 },
  };
}

/** Table column id → the `sort` key the list endpoint takes. */
const DOMAIN_SORT_KEYS: Record<string, string> = {
  domain: 'domain',
  version: 'version',
  created: 'created_at',
  updated: 'updated_at',
};

export function domainSortParams(sorting: { id: string; desc: boolean }[]): { sort: string; order: 'asc' | 'desc' } {
  const first = sorting[0];
  const key = first ? DOMAIN_SORT_KEYS[first.id] : undefined;
  return key ? { sort: key, order: first.desc ? 'desc' : 'asc' } : { sort: 'domain', order: 'asc' };
}
